import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";

export default function ToastMessage({ showToast, setShowToast, fbStatus, toastVariant }) {
	return (
		<>
			{/* Bootstrap Toast */}
			<ToastContainer position="bottom-center" className="p-3">
				<Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} bg={toastVariant} autohide>
					<Toast.Body>
						{toastVariant === "success" ? (
							<i className="bi bi-check-circle-fill me-2"></i>
						) : (
							<i className="bi bi-x-circle-fill me-2"></i>
						)}
						{fbStatus}
					</Toast.Body>
				</Toast>
			</ToastContainer>
		</>
	);
}
